export const FETCH_INVOICES = 'FINANCE/FETCH_INVOICES'
export const SET_INVOICES_FILTER = 'FINANCE/SET_INVOICES_FILTER'
export const DROP_INVOICES_DATA = 'FINANCE/DROP_INVOICES_DATA'
export const RESET_INVOICES_DATA = 'FINANCE/RESET_INVOICES_DATA'
export const SET_INVOICES_DATA = 'FINANCE/SET_INVOICES_DATA'
